export const API_URL = "https://learningmanager-backend.onrender.com"